export default __webpack_public_path__ + "static/media/avatar.47f8c345.jpg";